/** @format */

import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/size/",
    name: "Sizes",
    component: () => import("../views/Sizes.vue"),
  },
  {
    path: "/commitment",
    name: "Commitment",
    component: () => import("../views/Commitment.vue"),
  },
  {
    path: "/details",
    name: "Details",
    component: () => import("../views/Details.vue"),
  },
  {
    path: "/offers",
    name: "Offers",
    component: () => import("../views/Offers.vue"),
  },
  {
    path: "/thankyou",
    name: "Thankyou",
    component: () => import("../views/Thankyou.vue"),
  },
];

const router = createRouter({
  mode: "history",
  history: createWebHistory("/gamma-verhuizen"),
  routes,
});

router.beforeEach((to, from, next) => {
  const currentPath = window.location.pathname;
  // Remove the base URL from route paths
  const fromPath = currentPath.replace("/gamma-verhuizen", "");
  const isReloading = fromPath === to.path;
  if (!isReloading) {
    fetch("https://www.googletagmanager.com/gtm.js?id=GTM-5VNPS9JR")
      .then((response) => response.text())
      .then((scriptText) => {})
      .catch((error) => {
        console.error("Error loading script:", error);
      });
  }
  next();
  // Google Tag Manager script
});
//GAMMA/ history: createWebHistory('/gamma'),
//REGULAR: history: createWebHistory(process.env.BASE_URL),

/*
GAMMA:
  {
    path: '/size/',
    name: 'Sizes',
    component: () => import('../views/Sizes.vue')
  },

REGULAR:
  {
    path: '/size/:g_size?/:g_rounded?/:g_offer?/:g_list?',
    name: 'Sizes',
    component: () => import('../views/Sizes.vue')
  },

*/

export default router;
